export default __webpack_public_path__ + "static/media/voidofmadness.da44df84.png";